var _rect, _rect2, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#ECEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 12C11 9.79086 12.7909 8 15 8H31C33.2091 8 35 9.79086 35 12V20C35 22.2091 33.2091 24 31 24H15C12.7909 24 11 22.2091 11 20V12Z",
    fill: "#6C6D89"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#6C6D89"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#6C6D89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#6C6D89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlaceholder);
export default __webpack_public_path__ + "static/media/card-placeholder.b0264b1b01830b87197c8fe3c0b86e3d.svg";
export { ForwardRef as ReactComponent };